import { Directive, HostListener, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {FormatInitialsDirective} from "@bca-shared/directives/format-initials.directive";

@Directive({
  selector: '[formatInitialsIE]'
})
export class FormatInitialsIEDirective {
  @Input() public formControl: FormControl;
  @Input() public formatInitials: any;

  // if special browser ( IE) then ensure good formatting with dots.
  @HostListener('keyup', ['$event'])
  public format(event: KeyboardEvent): string {

    const isIEorEdge = FormatInitialsDirective.isIEorEdge();
    const isChanged = !FormatInitialsIEDirective.isEventWithoutInputChange(event);

    if (isIEorEdge && isChanged) {// if changed then ensure the right formatting with dots
      const { target } = event;
      const originalValue = (target as HTMLInputElement).value;
      // tslint:disable

      // indien backspace, dan explicit het teken weghalen (anders werkt de backspace niet)
      const isBackSpace = event.keyCode === 8;
      if (isBackSpace) {
        return originalValue.substring(0, originalValue.length - 2);
      }

      let formattedValue = FormatInitialsDirective.formatString(originalValue).trim().toUpperCase();

      if (formattedValue.length > 10) {
        formattedValue = formattedValue.substring(0, 10);
      }


      const inputValue = formattedValue === this.formatInitials ? originalValue : formattedValue;
      (target as HTMLInputElement).value = inputValue;
      this.formControl.setValue(inputValue);
    }
  }
  public static isEventWithoutInputChange(event: KeyboardEvent): boolean {
    if (!event.keyCode) {
      return true;
    }
    const number = Number(event.keyCode);
    const isCursorKey = (number >36 && number<41);
    const isCtrlA = number == 65 && event.ctrlKey;

    return isCursorKey || isCtrlA;
  }
}
